import { useTopItems } from './useTopItems';
import { useBottomItems } from './useBottomItems';
import { useUserData } from './useUserData';
import { ISidebarProps } from './types';

export const useSidebarProps = (props: ISidebarProps) => {
  const topItems = useTopItems(props);
  const bottomItems = useBottomItems(props);
  const userData = useUserData(props);

  return {
    topItems,
    bottomItems,
    userData,
  };
};
